const JsMagnific = {
	init () {

		/*
		* Magnific Popup, I think it's used for the WHO section
		*/

		$('#magnific-who').magnificPopup({
			delegate: 'a',
			type: 'image'
			// other options
		});

		$('.magnific-snapchat').magnificPopup({
			// delegate: 'a',
			type: 'image'
			// other options
		});

	}
};

export default JsMagnific;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/magnific.js